export enum ContratacionEstrategica {
  COMPRA_INNOVADORA = 40508,
  CLAUSULAS_SOCIALES = 40509,
  CLAUSULAS_AMBIENTALES = 40510,
}
